import { Injectable, signal, Type } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface ModalConfig {
  component: Type<any>;
  inputs?: Record<string, any>;
  title?: string;
  closeOnBackdrop?: boolean;
  top?: number;
  admin?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ModalService {
  readonly config = signal<ModalConfig | null>(null);
  private resultSubject = new Subject<any>();
  shouldClose = signal(false);

  open(config: ModalConfig): Observable<any> {
    this.config.set({ closeOnBackdrop: true, ...config });
    return this.resultSubject.asObservable();
  }

  discardModal(result: boolean): void {
    this.resultSubject.next(result);
    this.config.set(null);
    this.shouldClose.set(false);
  }

  onBackdropClick(closeOnBackdrop?: boolean): void {
    if (closeOnBackdrop) {
      this.shouldClose.set(true);
    }
  }
}
